module.exports = __webpack_public_path__ + "static/media/chess.408731da.mp4";